import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMachines } from "../../../redux/Machine/actions";
import { getAllUsers } from "../../../redux/User/actions";
import AddMachineButton from "./AddMachineButton";
import MachineCard from "./MachineCard";
import { Input, Breadcrumb, Empty } from "antd"; // Correct import from antd
import Grid from "@material-ui/core/Grid";

const { Search } = Input;

export const Machines = () => {
  const dispatch = useDispatch();
  const machines = useSelector((state) => state.machines?.machines || []);
  const users = useSelector((state) => state.Users?.data || []);
  const [machineSearch, setMachineSearch] = useState([]);
  const [searchMode, setSearchMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    setLoading(true);
    dispatch(fetchMachines()).finally(() => setLoading(false));
    dispatch(getAllUsers());
  }, [dispatch]);

  const handleSearch = (value) => {
    if (value.length > 0) {
      setSearchMode(true);
      const filteredMachines = machines.filter((el) =>
        el.machinename.toLowerCase().includes(value.toLowerCase())
      );
      setMachineSearch(filteredMachines);
    } else {
      setSearchMode(false);
      setMachineSearch([]);
    }
    setSearchInput(value);
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchInput(value);
    if (value.length === 0) {
      setSearchMode(false);
      setMachineSearch([]);
    }
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Machines</Breadcrumb.Item>
        <div style={{ float: "right", marginTop: 20 }}>
          <Grid container>
            <Grid item>
              <Search
                placeholder="Search"
                value={searchInput}
                onChange={handleSearchChange}
                style={{ minWidth: 150, maxWidth: 220 }}
                enterButton
                onSearch={handleSearch}
              />
              <AddMachineButton users={users} />
            </Grid>
          </Grid>
        </div>
      </Breadcrumb>
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            {loading ? (
              <Empty description="Loading machines..." />
            ) : searchMode ? (
              machineSearch.length === 0 ? (
                <Empty description="No machines found" />
              ) : (
                machineSearch.map((item) => (
                  <Grid key={item._id} item>
                    <MachineCard item={item} users={users} />
                  </Grid>
                ))
              )
            ) : machines.length === 0 ? (
              <Empty description="No machines available" />
            ) : (
              machines.map((item) => (
                <Grid key={item._id} item>
                  <MachineCard item={item} users={users} />
                </Grid>
              ))
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Machines;
